import { TYPES } from '../../common/constants';
import * as client from '../../services/client';

const getSuiteStatusesDone = (payload) => ({
    type: TYPES.GET_SUITE_STATUSES_DONE,
    payload
});

export const getSuiteStatuses = () => dispatch => {
    return client.getSuiteStatuses().then(response => {
        if(response.status === 200 || response.ok){
            response.json().then(
                responsejson => {
                    dispatch(getSuiteStatusesDone(responsejson))
                }
            )
        }
    })
}

